import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import BrandmappingMappedInfoComponent from './barnd-mapping-mapped-info.component';
import BrandMappingInfoComponent from './brand-mapping-info.component';
import { UploadMedia } from '../../../../../common/components/common/upload-media';

export const BrandMappingComponent = ({ websites, webpages, tenantFunctions, templates,
    handleFormItemChange,
    orgRegistries,
    dbas,
    deleteSelectedFunctions,
    tenantFunction,
    products,
    deliveries,
    collectionPolicies,
    tierPrices,
    rewards,
    discounts,
    organizationUnits,
    accounts,
    topics,
    collections,
    channels,
    announcements,
    categories,
    selectedFunctions,
    changeFavImage, changeLogoImage, brandMappings, faviconSize, logoBackground, logoFiles,
    onFormItemBrandChange, onFormLogoItemChange, onFormFavItemChange, handleClose, back, handleFormSubmit,
    onFormItemChange,
    policyOwnerType, accountTypesList, accountTypesListLoading, accountsList, accountListLoading, onInnerBasicFormChange
    , id, entityType
}: any) => {

    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };

    const tabItems = [
        {
            id: 1,
            title: 'Brand Mapping Information',
            component: <BrandMappingInfoComponent
                handleClose={handleClose}
                onFormItemBrandChange={onFormItemBrandChange}
                logoFiles={logoFiles}
                changeFavImage={changeFavImage}
                onFormLogoItemChange={onFormLogoItemChange}
                faviconSize={faviconSize}
                changeLogoImage={changeLogoImage}
                logoBackground={logoBackground}
                brandMappings={brandMappings}
                onFormFavItemChange={onFormFavItemChange}
                handleFormSubmit={handleFormSubmit}
                websites={websites}
                webpages={webpages}
                onInnerBasicFormChange={onInnerBasicFormChange}
                policyOwnerType={policyOwnerType}
                accountTypesList={accountTypesList}
                accountTypesListLoading={accountTypesListLoading}
                accountsList={accountsList}
                accountListLoading={accountListLoading}
            />,
            isVisible: true,
        },

        {
            id: 2,
            title: 'Mapped Entities',
            component: <BrandmappingMappedInfoComponent
                entityType={entityType}
                websites={websites}
                webpages={webpages}
                templates={templates}
                tenantFunction={tenantFunctions}
                selectedFunctions={selectedFunctions}
                categories={categories}
                deleteSelectedFunctions={deleteSelectedFunctions}
                handleFormItemChange={handleFormItemChange}
                announcements={announcements}
                channels={channels}
                collections={collections}
                topics={topics}
                accounts={accounts}
                organizationUnits={organizationUnits}
                discounts={discounts}
                rewards={rewards}
                tierPrices={tierPrices}
                collectionPolicies={collectionPolicies}
                deliveries={deliveries}
                products={products}
                orgRegistries={orgRegistries}
                dbas={dbas}
            />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Media',
            component:
                <UploadMedia
                    handleInnerFormChange={handleInnerMediaFormChange}
                    mediaFilesList={brandMappings?.MediaMappings?.MediaFiles}
                    ownerTypeId={1007}
                    ownerId={id}
                    folderName={'brandmapping'}
                />,
            isVisible: true,
        },

    ]

    return (
        <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default BrandMappingComponent;
